import styled from 'styled-components';
// import { Row as AntdRow, message } from 'antd';
// import { useTranslation } from 'react-i18next';

const SupportPageContainer = styled.div`
  margin: 0;
`;

// const Row = styled(AntdRow)`
//   margin-bottom: 2.5rem;
// `;
function UserguidePage() {
  // const { t } = useTranslation();
  return <SupportPageContainer></SupportPageContainer>;
}

export default UserguidePage;
